import React, { useEffect } from "react";
import { motion } from "framer-motion";

const TermsAndConditionspage = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to top when component loads
      }, []);
  return (
    <div className="bg-white text-white min-h-screen p-8 py-40">
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-3xl font-bold text-yellow-600 text-center"
      >
        Terms & Conditions
      </motion.h1>

      <div className="max-w-3xl mx-auto mt-6 space-y-6 text-gray-700">
        <motion.p
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-lg"
        >
          Welcome to SnapBucks! By accessing this website, you agree to comply with our terms and conditions. Please read them carefully.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="bg-gray-100 p-4 rounded-lg border-l-4 border-yellow-500"
        >
          <h2 className="text-xl text-yellow-500 font-semibold">1. User Agreement</h2>
          <p className="text-gray-700 mt-2">
            By using SnapBucks, you confirm that you are legally permitted to enter into this agreement and will use our services responsibly.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="bg-gray-100 p-4 rounded-lg border-l-4 border-yellow-500"
        >
          <h2 className="text-xl text-yellow-500 font-semibold">2. Intellectual Property</h2>
          <p className="text-gray-700 mt-2">
            All content, branding, and assets on this site belong to SnapBucks. Any unauthorized use or reproduction is strictly prohibited.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="bg-gray-100 p-4 rounded-lg border-l-4 border-yellow-500"
        >
          <h2 className="text-xl text-yellow-500 font-semibold">3. Limitation of Liability</h2>
          <p className="text-gray-700 mt-2">
            SnapBucks is not responsible for any indirect or incidental damages arising from the use of this website.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 1.0 }}
          className="bg-gray-100 p-4 rounded-lg border-l-4 border-yellow-500"
        >
          <h2 className="text-xl text-yellow-500 font-semibold">4. Privacy Policy</h2>
          <p className="text-gray-700 mt-2">
            We respect your privacy. Personal data is securely stored and never shared with third parties without consent.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 1.2 }}
          className="bg-gray-100 p-4 rounded-lg border-l-4 border-yellow-500"
        >
          <h2 className="text-xl text-yellow-500 font-semibold">5. Governing Law</h2>
          <p className="text-gray-700 mt-2">
            These terms are governed by the laws of [Your Country/State]. Disputes must be resolved in accordance with applicable legal frameworks.
          </p>
        </motion.div>
      {/* Sticky Disclaimer */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 1.4 }}
        className=" w-full  rounded-lg bg-yellow-600 text-black text-center py-3 font-semibold"
      >
        ⚠ Disclaimer: This is the only official website of SnapBucks. Beware of fraudulent sites.
      </motion.div>
      </div>

    </div>
  );
};

export default TermsAndConditionspage;
